import { Alert, Button } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { billingCurrentApi } from "../../config/Api";
import { ADMIN_ROLE, ROLE_KEYWORD } from "../../config/constant";
import { readCookie } from "../../config/CookieScript";

// shown when the plan has this many active-client slots left, or fewer
const SLOTS_LEFT_WARNING = 5

// "Upgrade plan" prompt for doctors: on Client List only when the plan is nearly full,
// on Profile always (always: true), with their plan usage
export const UpgradePlanNotice = ({ className = 'mb-3', always = false }) => {
    const navigate = useNavigate()
    const [current, setCurrent] = useState(null)

    useEffect(() => {
        if (readCookie(ROLE_KEYWORD) == ADMIN_ROLE) return
        billingCurrentApi().then((res) => setCurrent(res.data.data)).catch(() => {})
    }, [])

    if (!current?.plan) return null

    const limit = current.plan.active_clients
    const used = current.active_clients_used
    const left = Math.max(0, limit - used)
    const nearlyFull = left <= SLOTS_LEFT_WARNING
    if (!nearlyFull && !always) return null

    if (!nearlyFull) {
        return (
            <Alert
                className={className}
                type="info"
                showIcon
                message={`You're on the ${current.plan.name} plan: ${used} of ${limit.toLocaleString('en-IN')} active clients used.`}
                action={<Button onClick={() => navigate('/my-plan')}>Upgrade plan</Button>}
            />
        )
    }

    return (
        <Alert
            className={className}
            type={left === 0 ? 'error' : 'warning'}
            showIcon
            message={left === 0
                ? `Your ${current.plan.name} plan is full: ${used} of ${limit} active clients.`
                : `${used} of ${limit} active clients used on your ${current.plan.name} plan (${left} left).`}
            description="Upgrade your plan to add more active clients, or deactivate clients you no longer work with."
            action={<Button type="primary" onClick={() => navigate('/my-plan')}>Upgrade plan</Button>}
        />
    )
}
